import { render } from "./BasicProjectNumCard.vue?vue&type=template&id=150d7051"
import script from "./BasicProjectNumCard.vue?vue&type=script&lang=js"
export * from "./BasicProjectNumCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__